// front-end/src/config/supabase.ts
import { createClient } from '@supabase/supabase-js';

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL || 'https://flwwivrgccqacrcjoaot.supabase.co';
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY || 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImZsd3dpdnJnY2NxYWNyY2pvYW90Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTUzMjY5NDQsImV4cCI6MjA3MDkwMjk0NH0.9LkMC_wArbeFWloeC9Oyt4LRnBU6tBy22TBwWaaaQ4Y';

if (!supabaseUrl || !supabaseAnonKey) {
  throw new Error('Supabase URL e Anon Key sono richiesti');
}

console.log('Configurazione Supabase:', { 
  url: supabaseUrl, 
  hasKey: !!supabaseAnonKey,
  hasLocalStorage: typeof window !== 'undefined' && !!window.localStorage
});

// Verifica che window.localStorage sia disponibile
const storage = typeof window !== 'undefined' ? window.localStorage : undefined;

export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    autoRefreshToken: true,
    persistSession: true,
    storage: storage
  }
});

console.log('Supabase client creato:', supabase);

// Test immediato della connessione
setTimeout(async () => {
  try {
    console.log('Test connessione Supabase...');
    const { data, error } = await supabase.auth.getSession();
    console.log('Test getSession completato:', { hasData: !!data, error });
  } catch (e) {
    console.error('Errore test connessione:', e);
  }
}, 100);

// Types per TypeScript
export interface UserProfile {
  id: string;
  email: string;
  username: string;
  nome: string;
  cognome: string;
  ruolo: 'admin' | 'editor' | 'viewer';
  attivo: boolean;
  ultimo_accesso?: string;
  created_at: string;
  updated_at: string;
}

// Helper functions
export async function getUserProfile(userId: string): Promise<UserProfile | null> {
  try {
    console.log('🔍 getUserProfile: Ricerca profilo per userId:', userId);
    
    const { data, error } = await supabase
      .from('user_profiles')
      .select('*')
      .eq('id', userId)
      .single();
    
    console.log('📊 getUserProfile: Risposta query:', { data, error });
    
    if (error) {
      console.log('❌ getUserProfile: Errore trovato:', error.code, error.message);
      
      // Se il profilo non esiste, proviamo a crearlo
      if (error.code === 'PGRST116') {
        console.log('🚀 getUserProfile: Profilo non esistente, creo automaticamente');
        
        const { data: { user }, error: userError } = await supabase.auth.getUser();
        console.log('👤 getUserProfile: Dati utente corrente:', { user: !!user, userError });
        
        if (user && user.id === userId) {
          const newProfile = {
            id: userId,
            email: user.email!,
            username: user.email!.split('@')[0],
            nome: user.user_metadata?.nome || '',
            cognome: user.user_metadata?.cognome || '',
            ruolo: 'viewer' as const,
            attivo: true,
            created_at: new Date().toISOString(),
            updated_at: new Date().toISOString()
          };
          
          console.log('📝 getUserProfile: Creazione nuovo profilo:', newProfile);
          
          // Prova a inserire il nuovo profilo
          const { data: created, error: insertError } = await supabase
            .from('user_profiles')
            .insert(newProfile)
            .select()
            .single();
          
          console.log('✅ getUserProfile: Risultato inserimento:', { created, insertError });
          
          if (!insertError) {
            console.log('🎉 getUserProfile: Profilo creato con successo');
            return created;
          } else {
            console.error('💥 getUserProfile: Errore inserimento profilo:', insertError);
          }
        }
      }
      console.error('❌ getUserProfile: Errore recupero profilo:', error);
      return null;
    }
    
    console.log('✅ getUserProfile: Profilo trovato con successo');
    return data;
  } catch (error) {
    console.error('💥 getUserProfile: Errore catch:', error);
    return null;
  }
}

export async function updateLastAccess(userId: string): Promise<void> {
  try {
    await supabase.rpc('update_ultimo_accesso', { user_id: userId });
  } catch (error) {
    console.error('Errore aggiornamento ultimo accesso:', error);
  }
}

export default supabase;